import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrderPageRequest = {};
var _createOrderPageResponse = {};
var _currentSubscriptionInfo = {
    periodEndDate: 'google.protobuf.Timestamp',
    freeTrialData: '_freeTrialData',
};
var _freeTrialData = { endDate: 'google.protobuf.Timestamp' };
var _getB2BUserOfferingRequest = {};
var _getB2BUserOfferingResponse = {};
var _getProductInfoRequest = {};
var _getProductInfoResponse = {};
var _getUserOfferingRequest = {};
var _getUserOfferingResponse = {
    offerValidUntil: 'google.protobuf.Timestamp',
    currentSubscriptionInfo: '_currentSubscriptionInfo',
};
var _provisionProductsRequest = {};
var _provisionProductsResponse = {};
var _validateNoPreviousPurchaseRequest = {};
var _validateNoPreviousPurchaseResponse = {};
function resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-store',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/pricing',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/studio/pricing',
                destPath: '/upgradeWebsite',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-store',
                destPath: '',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/store',
                destPath: '/api',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
        ],
        _: [
            {
                srcPath: '/_api/store/plans/premiumStatus',
                destPath: '/api/plans/premiumStatus',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/store',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/pricing/premium-plans',
                destPath: '/plans',
            },
            {
                srcPath: '/store',
                destPath: '',
            },
            {
                srcPath: '/upgrade/website',
                destPath: '/upgradeWebsite',
            },
            {
                srcPath: '/_api/mailbox-store',
                destPath: '',
            },
            {
                srcPath: '/_api/premium-store',
                destPath: '/api',
            },
            {
                srcPath: '/wix/api/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/_api/wix/premiumStart',
                destPath: '/plans',
            },
            {
                srcPath: '/wix/api/premiumStartTest',
                destPath: '/plans',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a user offering for the given product type. If you also specify a
 * `productFamilyId` only products that belong to this family are included in the
 * user offering. You can limit the returned products by providing additional
 * `customOfferingFilters`.
 *
 *
 * A user offering consists of all products that the customer can purchase,
 * including billing cycle durations, features, and relevant pricing details.
 * Note that the currency rate remains fixed. That means, if you set a
 * product's price at 100 USD with an initial EUR exchange rate of 1.05 USD,
 * the price for European customers is always 105 EUR. This won't change even
 * if the EUR-USD exchange rate fluctuates.
 *
 * In case you haven’t integrated with the
 * [Dealer](https://wix-marketing.wixanswers.com/en/article/dealer-faqs), the
 * endpoint returns all `PUBLISHED` products of the given product type. Then,
 * you may need to add your own filtering before populating the purchase
 * funnel pages. This is especially important, if you add products to a
 * specific product type after its initial setup.
 *
 * The response includes `displayProperties` for the product type, the
 * products, and the features. But they're limited to the fields listed in the
 * `translatable` parameter of the relevant
 * [`displayAttributes` object](https://dev.wix.com/docs/rest/internal-only/premium/premium-display-manager/display-attributes/product-display-attributes-object).
 */
export function getUserOffering(payload) {
    var _a = serializer(_getUserOfferingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUserOfferingResponse, {
        _currentSubscriptionInfo: _currentSubscriptionInfo,
        _freeTrialData: _freeTrialData,
    }).fromJSON;
    function __getUserOffering(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.GetUserOffering',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/offering/{productTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUserOffering.fromReq = fromReq;
    __getUserOffering.__isAmbassador = true;
    return __getUserOffering;
}
/**
 * Retrieves B2B users information about products that can be provisioned to their sites.
 * The response includes details about products, associated features and `displayProperties`
 * for the product type, the products and the features. They're limited to the fields listed
 * in the `translatable` parameter of the relevant [`displayAttributes` object](https://dev.wix.com/docs/rest/internal-only/premium/premium-display-manager/display-attributes/product-display-attributes-object).
 *
 * Eligible products are provided by the reseller management system ('premium-reseller-mgmt'),
 * which manage the contract of the B2B user with Wix. Only products associated
 * with the B2B user's contract will be included in the response.
 */
export function getB2BUserOffering(payload) {
    var _a = serializer(_getB2BUserOfferingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getB2BUserOfferingResponse, {}).fromJSON;
    function __getB2BUserOffering(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.GetB2BUserOffering',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/b2b-user-offering/{productTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getB2BUserOffering.fromReq = fromReq;
    __getB2BUserOffering.__isAmbassador = true;
    return __getB2BUserOffering;
}
/**
 * Retrieves pricing and display information for the specified product.
 *
 *
 * The response of the Get Product Info call includes details about
 * the product's pricing and
 * [display attributes](https://dev.wix.com/docs/rest/internal-only/premium/premium-display-manager/display-attributes/product-display-attributes-object).
 * In contrast, calling the
 * [Get Product endpoint](https://dev.wix.com/docs/rest/internal-only/premium/premium-product-catalog-v2/products/get-product)
 * of the Premium Product Catalog V2 API doesn’t return pricing and display
 * details, but instead information about coupons and vouchers that are
 * associated with the product.
 */
export function getProductInfo(payload) {
    var _a = serializer(_getProductInfoRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProductInfoResponse, {}).fromJSON;
    function __getProductInfo(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.GetProductInfo',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/productInfo/{productId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProductInfo.fromReq = fromReq;
    __getProductInfo.__isAmbassador = true;
    return __getProductInfo;
}
/**
 * Generates the `orderSessionId` and `riskIframeUrl` for an order page that contains
 * the specified products.
 *
 *
 * After calling this endpoint, you need to forward the response to the
 * client’s URL so that the customer is able to see the order page.
 */
export function createOrderPage(payload) {
    var _a = serializer(_createOrderPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderPageResponse, {}).fromJSON;
    function __createOrderPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.CreateOrderPage',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/createOrderPage',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrderPage.fromReq = fromReq;
    __createOrderPage.__isAmbassador = true;
    return __createOrderPage;
}
/**
 * Provision products and create an active subscription.
 * Only products associated with the B2B user's contract can be provisioned.
 */
export function provisionProducts(payload) {
    var _a = serializer(_provisionProductsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_provisionProductsResponse, {}).fromJSON;
    function __provisionProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.ProvisionProducts',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/provision-products',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __provisionProducts.fromReq = fromReq;
    __provisionProducts.__isAmbassador = true;
    return __provisionProducts;
}
/**
 * Checks that the customer hasn’t purchased the same product during the
 * last 2 days. This helps prevent unintentional double purchases.
 */
export function validateNoPreviousPurchase(payload) {
    var _a = serializer(_validateNoPreviousPurchaseRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateNoPreviousPurchaseResponse, {}).fromJSON;
    function __validateNoPreviousPurchase(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.store.v1.dynamic_offering_service_entity',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.store.checkout.v1.DynamicOfferingApi.ValidateNoPreviousPurchase',
            url: resolveComWixpressPremiumStoreCheckoutV1DynamicOfferingApiUrl({
                protoPath: '/api/v1/ValidateNoPreviousPurchase',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateNoPreviousPurchase.fromReq = fromReq;
    __validateNoPreviousPurchase.__isAmbassador = true;
    return __validateNoPreviousPurchase;
}
//# sourceMappingURL=http.impl.js.map